import styled from 'styled-components';
import { gray4 } from '@styles/styled/variables';

export const Rates = styled.div`
  margin-top: 16px;
  padding: 0 16px;
  white-space: normal;

  table {
    font-size: 16px;
    font-weight: 300;
    width: 100%;

    td,
    th {
      border-bottom: 1px solid ${gray4};
      padding: 8px 0;
    }

    th:nth-child(1),
    th:nth-child(2) {
      padding-right: 16px;
      min-width: 140px;
    }
  }
`;

export const Tabs = styled.div`
  background: white;
  min-height: 47px;
`;

export const Wrapper = styled.div`
  padding: 8px;
`;

export const StyledTabs = styled.div`
  display: flex;
  margin-bottom: 10px;

  a {
    text-decoration: none;
  }
`;
